/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Col_MaxInputs */

const en_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const de_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const fr_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const es_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máx.`)
};

const it_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const nl_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const pl_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const fi_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const da_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maks`)
};

const sv_salary_col_max = /** @type {(inputs: Salary_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

/**
* | output |
* | --- |
* | "Max" |
*
* @param {Salary_Col_MaxInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_col_max = /** @type {((inputs?: Salary_Col_MaxInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Col_MaxInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_col_max(inputs)
	if (locale === "fr") return fr_salary_col_max(inputs)
	if (locale === "es") return es_salary_col_max(inputs)
	if (locale === "it") return it_salary_col_max(inputs)
	if (locale === "nl") return nl_salary_col_max(inputs)
	if (locale === "pl") return pl_salary_col_max(inputs)
	if (locale === "fi") return fi_salary_col_max(inputs)
	if (locale === "da") return da_salary_col_max(inputs)
	if (locale === "sv") return sv_salary_col_max(inputs)
	return en_salary_col_max(inputs)
});